import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectTenantService } from '../../../../data/services/select-tenant.service';
import { AuthIdentityResponse } from '../../../../data/models/interfaces/auth-response.interface';
import { AuthService } from '../../../../data/services/auth.service';
import { UserUtil } from '../../../../data/utils/user.utils';
import { MatDialog } from '@angular/material/dialog';
import { RedirectToAppStoresComponent } from '../../redirect-to-app-stores/redirect-to-app-stores.component';

@Component({
  selector: 'app-select-tenant',
  templateUrl: './select-tenant.component.html',
  styleUrls: ['./select-tenant.component.scss']
})
export class SelectTenantComponent implements OnInit {
  identities: AuthIdentityResponse[] = [];
  loading: boolean = false;

  constructor(
    private readonly selectTenantService: SelectTenantService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly userUtil: UserUtil,
    private readonly dialog: MatDialog
  ) { }

  async ngOnInit(): Promise<void> {
    const identities = this.selectTenantService.getIdentities();

    if (!identities || identities.length === 0) {
      await this.authService.logout();
      await this.router.navigate(['/login']);
      return;
    }

    this.identities = identities;
  }

  async selectIdentity(identity: AuthIdentityResponse): Promise<void> {
    try {
      this.loading = true;

      await this.selectTenantService.selectIdentity(identity);

      await this.routeTo();
    } catch (error) {
      console.log('failed to select identity (tenant)', error);
    }
    finally {
      this.loading = false;
    }
  }

  private async routeTo(): Promise<void> {
    if (this.userUtil.isResponsablesProfile() || this.userUtil.isChild()) {
      await this.authService.logout();
      await this.router.navigate(['/login']);
      this.dialog.open(RedirectToAppStoresComponent);
      return;
    }
    let route = 'news-list';
    if (this.userUtil.isFuncionarioProfile()) {
      route = 'users';
    }
    if (this.userUtil.isProfessorProfile()) {
      route = 'chat';
    }

    if(this.userUtil.isAdminProfile() && this.userUtil.hasManySchools()) {
      route = 'select-school';
    }

    await this.router.navigate([route]);
  }
}
